import { render, staticRenderFns } from "./FormInstrutor.vue?vue&type=template&id=f689e216"
import script from "./FormInstrutor.vue?vue&type=script&lang=js"
export * from "./FormInstrutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports